import { ConfigService } from '@nextgen-web-framework/core';
import getEnv from './getEnvVariable';

/**
 * This function servers as a replacement for process.env.KEY as the proocess.env.KEY syntax
 * is converted into string value on next build, which is not aligned with current build
 * process where we're building once and deploying everywhere.
 *
 * @param key environment variable whose value needs to be found
 * @returns
 */
const getTenantAndEnvKey = function () {
  const config = ConfigService.getConfigs();

  if (Object.keys(config).length == 0) {
    if (typeof window !== 'undefined') {
      return `${window.NEXT_PUBLIC_TENANT_NAME}_${window.NEXT_PUBLIC_TENANT_ENV}`;
    } else {
      return getEnv('TENANT_NAME')?.length > 0 ? `${getEnv('TENANT_NAME')}_${getEnv('TENANT_ENV')}` : '';
    }
  } else {
    return `${config.NEXT_PUBLIC_TENANT_NAME}_${config.NEXT_PUBLIC_TENANT_ENV}`;
  }
};

export default getTenantAndEnvKey;
